import * as React from 'react'

const SvgMenuHamburgerOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path stroke="#60636B" strokeWidth="2" strokeLinecap="round" d="M3 6h18M3 12h18M3 18h18" />
  </svg>
)
export default SvgMenuHamburgerOutlined
